import { getTenant } from '@/utils/tenant';

const getTenantColors = () => {
  const tenant = getTenant();

  if (tenant === 'spain') {
    return {
      selected: '#B58344',
      descriptionBg: '#B58344',
      liveBg: 'linear-gradient(99deg, #B58344 13.3%, #F2B60F 86.79%)',
      icon: '#B58344',
      borderActive: '#B58344',
      textActive: '#B58344',
      incorrect: '#B58344',
      eliminatedText: '#B58344',
      gradientCasino: 'linear-gradient(99deg, #173476 13.21%, #B58344 86.79%)',
      incorrectBg: '#B58344',
      borderColor: '#B58344',
    };
  }

  return {
    selected: '#F73535',
    descriptionBg: '#F73535',
    liveBg: 'linear-gradient(99deg, #F73535 13.3%, #F2B60F 86.79%)',
    icon: '#F73535',
    borderActive: '#F73535',
    textActive: '#F73535',
    incorrect: '#F73535',
    eliminatedText: '#F73535',
    gradientCasino: 'linear-gradient(99deg, #173476 13.21%, #F73535 86.79%)',
    incorrectBg: '#F73535',
    borderColor: '#F73535',
  };
};

export const tenantColors = getTenantColors();
